<template>
  <div class="legal-doc">
    <section id="promo-doc-1" class="legal-section">
      <h3 class="terms-title">
        1. 利用規約と条件
      </h3>
      <p>
        1.1 TIGER CASINOのプロモーションへ参加するお客様は、本規約、TIGER CASINO利用規約、各プロモーションページ、告知、メールまたはアカウント内で表示される個別条件に同意したものとみなされます。
      </p>
      <p>
        1.2 個別プロモーションに特別な条件がある場合は、その個別条件が優先されます。内容に同意いただけない場合は、プロモーションへの参加をお控えください。
      </p>
    </section>
    <section id="promo-doc-2" class="legal-section">
      <h3 class="terms-title">
        2. ボーナス
      </h3>
      <p>
        2.1 ボーナスとは、お客様のアカウントまたはボーナスウォレットへ付与される特典残高、無料スピン、キャッシュ特典、またはこれらに類するプロモーション特典を指します。ボーナスは原則として直接出金できず、指定された賭け条件、対象ゲーム、有効期限、その他の条件を満たした場合に限り、現金残高へ変換または出金可能となります。
      </p>
      <h4 class="legal-subtitle">
        2.2 ボーナスウォレット
      </h4>
      <p>
        2.2.1 ボーナスウォレットは、特定のプロモーションで付与されるボーナスマネーおよび関連する残高を管理する専用ウォレットです。メインウォレットその他のウォレットとは分離して管理されます。
      </p>
      <p>
        2.2.2 ボーナスウォレット内の残高は原則として直接出金することはできません。
      </p>
      <p>
        2.2.3 指定された賭け条件その他の条件を達成したボーナスについては、出金画面に設置されているスワップ機能（ウォレット振替）を利用し、お客様ご自身でボーナスウォレットからメインウォレットまたは対応する任意の仮想通貨ウォレットへ振り替える必要があります。
      </p>
      <p>
        2.2.4 出金を希望する場合は、賭け条件を達成したボーナス残高を出金可能なウォレットへ振り替えた後、当該ウォレットから出金申請を行ってください。
      </p>
      <p>
        2.2.5 ボーナスウォレットから仮想通貨ウォレットへ振り替える場合、振替時点の適用レートに基づき自動的に換算されます。適用される換算レートは、スワップ操作時に確認することができます。
      </p>
      <p>
        2.2.6 なお、賭け条件を達成していないボーナス残高、または出金条件を満たしていない残高については、出金可能なウォレットへ振り替えることはできません。
      </p>
      <p>
        2.3 キャッシュボーナスは、指定された現金ウォレットまたは対象通貨に付与されるプロモーション特典です。適用条件、賭け条件、有効期限、対象ゲームは、各プロモーションで定めます。
      </p>
      <p>
        2.4 フリースピンは、指定されたスロットゲーム等で利用できる無料スピン特典です。対象ゲーム、有効期限、勝利金の扱い、出金条件は、各プロモーション条件に従います。
      </p>
      <h4 class="legal-subtitle">
        2.5 週間ボーナス(Weekly ボーナス)・月間ボーナス(Monthly ボーナス)
      </h4>
      <p>
        2.5.1 週間ボーナスおよび月間ボーナスは、対象期間中のお客様のリアルマネーでのゲームプレイ実績、VIPランク、プレイされたゲームの種類・特性その他TIGER CASINOが定める算定基準に基づき算出されるプロモーション特典です。
      </p>
      <p>
        2.5.2 VIPプログラム上に表示される週間ボーナスおよび月間ボーナスの割合は、TIGER CASINOがゲームプレイ実績等に基づき算出したボーナス基準額に対して適用される割合であり、お客様の総ベット額または有効BET額に直接適用される還元率を示すものではありません。
      </p>
      <p>
        2.5.3 ボーナス算定に使用されるゲームごとの特性、算定基準、係数その他の内部計算方法は、ゲーム提供条件その他の要因により異なる場合があります。
      </p>
      <p>
        2.5.4 週間ボーナスおよび月間ボーナスの対象期間、対象VIPランク、受取条件、有効期限、付与方法その他の詳細については、VIPプログラムページ、各プロモーションページまたはアカウント内表示等で案内します。
      </p>
      <p>
        2.5.5 ボーナスの適用条件として、個人情報の登録を完了している必要があります。個人情報の登録が未完了の場合、キャッシュベットの有無にかかわらず、ウィークリーボーナス・マンスリーボーナスを含むすべてのボーナスの対象外となります。
      </p>
    </section>
    <section id="promo-doc-3" class="legal-section">
      <h3 class="terms-title">
        3. 賭け条件
      </h3>
      <p>
        3.1 賭け条件とは、ボーナスまたは入金額を出金可能にするために必要なベット倍率を指します。ボーナスを利用しない場合でも、入金分に対して一定の賭け条件が適用される場合があります。
      </p>
      <p>
        3.2 各ボーナスの倍率、対象ゲーム、反映率、消化状況は、プロモーションページ、告知、メール、アカウント内表示等で確認できます。賭け条件の管理および達成状況の確認は、お客様ご自身の責任となります。
      </p>
      <p>
        3.3 複数のボーナスを保有する場合、それぞれの賭け条件が合算または個別に計算されることがあります。
      </p>
      <p>
        3.4 ボーナスの賭け条件をクリアーできずボーナスウォレットの残高が０になっても賭け条件はクリアーされません。ボーナスウォレット残高が原則100円未満の状態で新たに入金した場合、未消化の賭け条件は消滅する仕様となっています。
      </p>
    </section>
    <section id="promo-doc-4" class="legal-section">
      <h3 class="terms-title">
        4. 賭け条件への反映率
      </h3>
      <p>
        4.1 特別な記載がない限り、ゲーム種別ごとの賭け条件反映率は以下を基準とします。
      </p>
      <table class="legal-table">
        <thead>
          <tr>
            <th>ウォレット / ゲーム種別</th>
            <th>反映率</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ボーナスウォレット / スロット</td>
            <td>100%</td>
          </tr>
          <tr>
            <td>ボーナスウォレット / ライブカジノ</td>
            <td>20%</td>
          </tr>
        </tbody>
      </table>
      <p>
        4.2 対象外ゲーム、禁止ゲーム、除外ゲームが指定されている場合、当該ゲームでのベットは賭け条件へ反映されません。また、禁止ゲームでのプレイ自体が規約違反となる場合があります。
      </p>
    </section>
    <section id="promo-doc-5" class="legal-section">
      <h3 class="terms-title">
        5. 有効期限
      </h3>
      <p>
        5.1 ボーナス、フリースピン、賭け条件には有効期限が設定されます。期限内に条件を満たさない場合、ボーナスおよび関連勝利金は失効または回収される場合があります。
      </p>
      <p>
        標準設定例：
      </p>
      <table class="legal-table">
        <thead>
          <tr>
            <th>特典種別</th>
            <th>有効期限</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>入金不要ボーナス / ボーナスウォレット</td>
            <td>付与後30日間</td>
          </tr>
          <tr>
            <td>キャッシュボーナス</td>
            <td>付与後30日間</td>
          </tr>
          <tr>
            <td>フリースピン</td>
            <td>付与後7日間</td>
          </tr>
        </tbody>
      </table>
      <p>
        5.2 個別プロモーションに別途記載がある場合は、個別条件を優先します。
      </p>
    </section>
    <section id="promo-doc-6" class="legal-section">
      <h3 class="terms-title">
        6. 禁止・除外ゲーム
      </h3>
      <p>
        6.1 禁止ゲームまたは除外ゲームでプレイした場合、賭け条件に反映されないだけでなく、ボーナス、関連勝利金、プロモーション参加資格が無効となる場合があります。
      </p>
      <h4 class="legal-subtitle">
        6.2 ボーナスウォレット利用時の禁止ゲーム
      </h4>
      <ul class="terms-list">
        <li>パチンコ・パチスロ</li>
        <li>クラッシュゲーム</li>
        <li>ブラックジャック</li>
        <li>ルーレット</li>
        <li>Evolution社のFirst Personシリーズ</li>
      </ul>
      <p>
        6.3 キャッシュボーナス、フリースピン、その他プロモーションの禁止・除外ゲームは、各プロモーションページまたは告知で明示します。
      </p>
      <p>
        6.4 その他の禁止ゲームは<a href="/page/bonus-prohibit-games" @click.prevent="$router.push('/page/bonus-prohibit-games')">こちら</a>からご確認下さい。
      </p>
      <p>
        6.5 ※禁止ゲーム一覧ページに記載のボーナス禁止ゲームであっても、システム上はボーナス残高でプレイできる場合があります。ただし、プレイ可能であっても利用が認められていることを意味するものではありません。禁止ゲームでボーナス残高を使用した場合、出金申請時に利用規約違反と判断され、没収の対象となる場合があります。
      </p>
    </section>
    <section id="promo-doc-7" class="legal-section">
      <h3 class="terms-title">
        7. ベット制限
      </h3>
      <p>
        7.1 ボーナス利用中は、特定のスロットゲームのボーナスBuyなどの機能を利用できないことがあります。キャッシュボーナスまたはフリースピン由来の勝利金については、個別条件で別途定める場合を除き、ベット制限を設けない運用とすることがあります。
      </p>
    </section>
    <section id="promo-doc-8" class="legal-section">
      <h3 class="terms-title">
        8. 出金上限
      </h3>
      <p>
        8.1 ボーナスは、指定された賭け条件その他の条件を満たした後、スワップ機能（ウォレット振替）を利用してボーナスウォレットからメインウォレットまたは対応する仮想通貨ウォレットへ振り替えることで出金可能となります。
      </p>
      <p>
        8.2 出金を希望するお客様は、対象となるボーナス残高を出金可能なウォレットへ振り替えた後、当該ウォレットから出金申請を行う必要があります。
      </p>
      <p>
        8.3 ただし、プロモーションによっては出金上限またはウォレットへ振り替え可能な上限額が設定される場合があります。上限がある場合は、各プロモーションページ、告知、メールまたはアカウント内表示等で明示します。
      </p>
      <p>
        8.4 ※入金不要ボーナスが利用可能な場合、賭け条件達成後にメインウォレット等へ振替可能な金額の上限は15,000円となります。
      </p>
    </section>
    <section id="promo-doc-9" class="legal-section">
      <h3 class="terms-title">
        9. 出金
      </h3>
      <p>
        9.1 ボーナス残高がある状態で出金申請を行った場合、保有しているボーナス残高および当該ボーナスに関連する未消化残高はすべて失効します。
      </p>
    </section>
    <section id="promo-doc-10" class="legal-section">
      <h3 class="terms-title">
        10. ボーナス乱用と禁止行為
      </h3>
      <p>
        10.1 TIGER CASINOは、取引履歴、ゲーム履歴、アカウント情報、決済情報、端末情報、IP情報等を確認し、ボーナス乱用、不正利用、違法なゲームプレイ、共謀、詐欺行為を調査する権利を有します。
      </p>
      <p>
        10.2 以下の行為は禁止されます。
      </p>
      <ul class="terms-list">
        <li>複数アカウントまたは第三者との共謀により、ゲーム仕様やプロモーション条件を悪用する行為。</li>
        <li>出金目的で資金や勝利状態をゲーム内に保持し、後から別入金で利益化する行為。</li>
        <li>ストック型スロット、Collect機能、フリースピン蓄積機能等を利用し、条件回避や利益確保を狙う行為。</li>
        <li>ルーレットの赤黒同時ベット、バカラのプレイヤー/バンカー同時ベット等の相反ベット。</li>
        <li>外部ツール、ボット、自動化ソフト、統計支援ツール等を利用したプレイ。</li>
        <li>ボーナス条件を意図的に操作し、不正にベット額または利益を増加させる行為。</li>
        <li>VPN、プロキシ、位置情報偽装等によりリスク判定を回避する行為。</li>
        <li>ボーナス発動条件を意図的にトリガーする、またはゲーム構造を悪用する行為。</li>
      </ul>
      <p>
        10.3 違反が疑われる場合、TIGER CASINOは調査完了までアカウント、残高、出金申請、ボーナス、プロモーション参加資格を保留または制限できます。違反が確認された場合、ボーナスおよび関連勝利金の無効化、資金没収、参加資格剥奪、アカウント閉鎖等の措置を講じることがあります。
      </p>
    </section>
    <section id="promo-doc-11" class="legal-section">
      <h3 class="terms-title">
        11. その他
      </h3>
      <p>
        11.1 アカウント種別によってはプロモーションへ参加できない場合があります。TIGER CASINOは、プロモーション内容および本規約を事前通知なく変更、停止、終了する権利を有します。変更後の条件は、サイト上または対象プロモーションページに掲載された時点で効力を有します。
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'TigerPromo'
}
</script>
